export const SHELL_ACTION_INTENT = {
  LOGOUT: "logout",
  SWITCH_FI: "switchFi",
} as const;

export const SHELL_ACTION_FIELD = {
  INTENT: "intent",
  FINANCIAL_INSTITUTION: "financialInstitution",
} as const;

/** Parent shell route action target (see {@link rootShellAction}). */
export const SHELL_ACTION_PATH = "/" as const;
